<div class="ms-xxsmall-b accommodate-icon">
  <h3 class="ms-small-l ms-xxsmall-b medium-type font-body-1">{{ 'MMB.labels.emd' | finLocalization }}</h3>
  <ul *ngIf="emds?.length" class="no-list-style ms-small-l">
    <li class="inline-block" *ngFor="let emd of emds; let last = last">{{ emd.id }}{{ last ? '' : ',&nbsp;' }}</li>
  </ul>
  <p *ngIf="!emds || !emds.length" class="ms-small-l ms-xxsmall-b">{{ 'MMB.labels.noEmd' | finLocalization }}</p>
  <p class="ms-small-l ms-xxsmall-b font-body-2 nordic-blue-900-text">
    {{ 'MMB.labels.emdHelp' | finLocalization }}
  </p>
</div>
